import type { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import CheckCircleIcon from '@atlaskit/icon/core/check-circle';
import { Box, Inline, Stack, Text, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

import { FIELD_MAX_WIDTH } from '../fieldMaxWidth';
import FieldLabel from '../MultiSelect/FieldLabel';
import { mcpPermissionsMessages } from '../McpPermissions/messages';
import { agentMcpCapabilitiesWarningMessages } from './messages';

const cardStyles = xcss({
  width: '100%',
  maxWidth: FIELD_MAX_WIDTH,
  boxSizing: 'border-box',
  borderWidth: 'border.width',
  borderStyle: 'solid',
  borderColor: 'color.border',
  borderRadius: 'radius.xxlarge',
  padding: 'space.200',
});

const iconStyles = xcss({ flexShrink: 0 });

type AgentMcpCapabilitiesWarningProps = {
  /** The custom agent receiving access. */
  agentName: string;
};

const AgentMcpCapabilitiesWarning: FunctionComponent<
  AgentMcpCapabilitiesWarningProps
> = ({ agentName }) => (
  <Stack space="space.100">
    <Inline alignBlock="center">
      <FieldLabel>
        <FormattedMessage {...mcpPermissionsMessages.sectionTitle} />
      </FieldLabel>
    </Inline>
    <Box xcss={cardStyles}>
      <Inline space="space.200" alignBlock="start">
        <Box xcss={iconStyles} aria-hidden>
          <CheckCircleIcon label="" size="medium" color={token('color.icon')} />
        </Box>
        <Text as="p">
          <FormattedMessage
            {...agentMcpCapabilitiesWarningMessages.capabilities}
            values={{ agentName }}
          />
        </Text>
      </Inline>
    </Box>
  </Stack>
);

export default AgentMcpCapabilitiesWarning;
